import React, { useState, useEffect } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import {formatToWords} from '../utils/formatInWords';

function Income() {
  const { state, actions } = useAppContext();
  // Initialize local state from state
  const [values, setValues] = useState({
    salary: state.salary || '',
    spouseSalary: state.spouseSalary || '',
    otherIncome: state.otherIncome || ''
  });

  // Sync local state with state when state changes
  useEffect(() => {
    setValues({
      salary: state.salary || '',
      spouseSalary: state.spouseSalary || '',
      otherIncome: state.otherIncome || ''
    });
  }, [state.salary, state.spouseSalary, state.otherIncome]);
  
  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
  
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  return (
    <Box>
      <CardContent>
        <Box sx={{ mb: 2}}>
          <Typography variant='h6' sx={{color: 'primary.main', mb:2}}>Household Income (₹{formatToWords(state.salary*12 + state.spouseSalary*12 + state.otherIncome)})</Typography>
          <Typography variant="body1" component="h2" gutterBottom>
            Your monthly income after taxes
          </Typography>
        
          <TextField
            aria-label="Your monthly net income after taxes in rupees"
            value={formatNumber(values.salary)}
            onChange={handleChange('salary')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='net monthly income'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:<InputAdornment>/ month</InputAdornment>
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" component="h2" gutterBottom>
            Your spouse monthly income after tax
          </Typography>

          <TextField
            aria-label="Spouse monthly net income after taxes in rupees"
            value={formatNumber(values.spouseSalary)}
            onChange={handleChange('spouseSalary')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='net monthly income'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment:<InputAdornment>/ month</InputAdornment>
            }}
          />
        </Box>
        
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" component="h2" gutterBottom>
            Any other annual income (bonus, rental income etc)
          </Typography>
          
          <TextField
            aria-label="Other annual income such as bonus or rental income in rupees"
            value={formatNumber(values.otherIncome)}
            onChange={handleChange('otherIncome')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='net annual income'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              endAdornment: <InputAdornment>/ year</InputAdornment>
            }}
          />
        </Box>
      </CardContent>
    </Box>
  );
}

export default Income;